import { defineStore } from "pinia";
import { useGet, usePatch, usePost } from "~/composables/useApi";
import { OrderCheckoutType } from "@/enums/orderCheckoutType";
import { OrderStepType } from "@/enums/orderStepType";
import { RegisterData } from "@/types/login";
import { OrderCreateData } from "@/types/order";

export const useCheckoutStore = defineStore("checkout", {
	state: () => {
		return {
			order: null as any,
			response_payload: null as any,
			orders: null as any,
			payment: null as any,
			product: null as any,
			loading: true as boolean,
			no_offer: false as boolean
		};
	},
	actions: {
		clear() {
			this.order = null;
			this.payment = null;
		},
		async set_order(order: any) {
			this.order = order;
		},
		async set_response_payload(response_payload: any) {
			this.response_payload = response_payload;
		},
		async set_orders(orders: any) {
			this.orders = orders;
		},
		async set_payment(payment: any) {
			this.payment = payment;
		},
		async set_product(product: any) {
			this.product = product;
		},
		pick_product(product: any, clear_order: boolean = true) {

			const route = useRoute();
			if(clear_order) {
				this.clear();
			}
			const tmp_prod = {
				...product,
				checkout_type: product.product_type ||
					route.query.checkout_type
			}

			this.product = tmp_prod;
		},
		get_product() {
			return this.product
		},
		async client_exists(document: string) {
			try {
				return await usePost(`/client/exists/${document}`);
			} catch (e) {
				return false;
			}
		},
		async create_client(payload: RegisterData, headers: any = {}) {
			await usePost("/client", payload, headers);
		},
		async update_client(payload: object, document?: string) {
			await usePost(`/client/update/${document ?? this.order.document}`, payload);
		},
		async subscription_log(payload: object) {
			return await usePut(`/subscription/create/${this.order.id}`, payload);
		},
		async get_subscription_log() {
			return await useGet(`/subscription/find-by-order/${this.order.id}`);
		},
		async get_subscription_logs(subscription_id: string) {
			return await useGet(`/subscription/get-logs/${subscription_id}`).then((data) => {
				return data.data;
			});
		},

		async get_subscription_link(ies_id: string,id_inscricao: string,fdi_slug: string,cod_concurso: string,ies_slug: string,cpf: string) {
			return await useAnimaGetSubscriptionLink(ies_id,id_inscricao,fdi_slug,cod_concurso,ies_slug,cpf);
		},
		async create_order(payload: OrderCreateData) {
			return await usePost("/order", payload);
		},
		async upset_order_address(payload: any) {
			await usePut(`/order/${this.order.id}/update-address`, payload);
		},
		async update_order(payload: any) {
			return await usePatch(`/order/${this.order.id}`, payload);
		},
		async find_postcode(postcode: any) {
			return await useGet(
				`/core/cep/${postcode}`,
			).then((data) => {
				if (`${data?.erro}` === "true") throw new Error("CEP é inválido!");
				return data;
			});
		},
		async apply_voucher(code: string) {
			const { changes, success } = await usePatch(`/order/${this.order.id}/apply-voucher/${code}`);
			Object.keys(changes).forEach(field => {
				if (field === "product") {
					Object.keys(changes[field]).forEach(pf => {
						this.product[pf] = changes[field][pf];
					});
				}
				this.order[field] = changes[field];
			});
			return {success};
		},
		async process_payment(payment_type: any, credit_card: any) {
			this.payment = await usePost(`/order/checkout/${this.order.id}`, {
				payment_type,
				card_number: credit_card.number,
				card_cvv: credit_card.code,
				card_expiration_date: credit_card.val,
				card_holder_name: credit_card.name,
				installments: credit_card.installment,
				step: this.order.checkout_type == OrderCheckoutType.PREPAID ? OrderStepType.SUBSCRIPTION : OrderStepType.COMPLETED
			});
		},
		async getCalculateInstallmentsAmount() {
			try {
				return await useGet(`/pagarme/calculate_installments_amount?amount=${this.order.price}`);
			} catch (e) {
				return [];
			}
		},
		async find_from_id(id: string) {
			return useGet(`/order/payment-info/${id}`);
		},
		async get_score(document: string) {
			try {
				return await useGet(`/integration/integration/enem/${document}/score`);
			} catch (e) {
				return false;
			}
		},

		async get_available_fdi(order_id?: string) {
			return await useAnimaGetAvailableFdi(this.order ? this.order.id : order_id);
		},
	},
	persist: true
});
